import "core-js/modules/es.array.join.js";
function getFriendlyDurationParts(_ref, t) {
  var hours = _ref.hours,
    minutes = _ref.minutes,
    seconds = _ref.seconds;
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$showSeconds = _ref2.showSeconds,
    showSeconds = _ref2$showSeconds === void 0 ? false : _ref2$showSeconds;
  var parts = [];
  if (hours > 0) parts.push(t('hour_short', {
    count: hours
  }));
  if (minutes > 0) parts.push(t('minute_short', {
    count: minutes
  }));
  if (showSeconds && (seconds > 0 || parts.length === 0)) {
    parts.push(t('second_short', {
      count: seconds
    }));
  }
  if (parts.length === 0) {
    // Everything is zero and seconds are hidden.
    return t('minute_short', {
      count: minutes
    });
  }
  return parts.join(' ');
}
export default getFriendlyDurationParts;